import { useModal } from "@/features/modal/ModalStackManager";
import { FormButtonBox } from "@/features/standard/form/FormButtonBox";
import { FormMain } from "@/features/standard/form/FormMain";
import { FormSelect } from "@/features/standard/form/FormSelect";
import { FormWrapper } from "@/features/standard/form/FormWrapper";
import customAlert from "@/features/ui/alert/Alert";
import { validateFormValues } from "@/utils/validation";
import { Button, Checkbox, Flex, Text, TextInput } from "@mantine/core";
import { useForm } from "@mantine/form";

const Create = Object.assign(FormMain, {
  Button: Button,
  Input: TextInput,
  Checkbox,
  Select: FormSelect,
  Wrapper: FormWrapper,
  ButtonBox: FormButtonBox,
  Text: Text,
  Flex: Flex,
});

export const ALCModelUpdateForm = (params: any) => {
  const { formatterProps } = params;
  const { closeModal } = useModal();

  const form = useForm({
    initialValues: {
      partnerCode: formatterProps.partnerCode ?? undefined,
      siteSeq: formatterProps.siteSeq ?? undefined,
      modelName: formatterProps.modelName ?? undefined,
    },
  });

  const onSubmit = async () => {
    try {
      closeModal(form.values);

      customAlert("모델 수정에 실패하였습니다.", "수정 실패", "red");
    } catch (e) {
      customAlert("모델 수정에 실패하였습니다.", "수정 실패", "red");
    }
  };

  return (
    <Create.Wrapper>
      <Create.Input
        withAsterisk
        label="거래처"
        placeholder="거래처"
        {...form.getInputProps("partnerCode")}
      />
      <Create.Input
        label="사업자 번호"
        placeholder="사업자 번호"
        {...form.getInputProps("siteSeq")}
      />
      <Create.Input
        withAsterisk
        label="모델"
        placeholder="모델"
        {...form.getInputProps("modelName")}
      />
      <Create.ButtonBox>
        <Create.Button color="gray" onClick={closeModal}>
          취소
        </Create.Button>
        <Create.Button
          disabled={validateFormValues({
            pageType: "model",
            values: form.values,
          })}
          onClick={onSubmit}
        >
          모델 생성
        </Create.Button>
      </Create.ButtonBox>
    </Create.Wrapper>
  );
};
